import gql from "graphql-tag";
const image = gql `
  fragment ImageFormat on ImageFormat {
    height
    filename
    url
    width
  }

  fragment ImageFormats on ImageFormats {
    large {
      ...ImageFormat
    }
    medium {
      ...ImageFormat
    }
    small {
      ...ImageFormat
    }
    thumbnail {
      ...ImageFormat
    }
    xlarge {
      ...ImageFormat
    }
    xsmall {
      ...ImageFormat
    }
  }

  fragment Image on Image {
    alternativeText
    caption
    filename
    formats {
      ...ImageFormats
    }
    height
    id
    url
    width
  }
`;
export default image;
